// Content for /for/partners — white-label resale.
//
// TRACE: see the note at the top of schools.js.
//
// This page is platform-operator-only (`platformHostOnly` in registry.js). It must never render
// on a partner's own white-label host, where it would pitch that partner's prospects on becoming
// competing resellers.

export default {
    key: 'partners',
    eyebrow: 'For resellers, consultancies and utility providers',
    title: 'Sell energy transparency under your own brand',
    subtitle:
        'Run the whole platform as your product (your name, your logo, your colours, your subdomain), with a licence that defines what your clients get and a console to manage them.',
    heroChips: [
        'Full white-label',
        'Licence & entitlements',
        'Bulk provisioning'
    ],

    features: [
        {
            title: 'Your brand, from the login screen onwards',
            detail: 'Product name, logo, colours and support contact on your own subdomain: applied before anyone signs in, so clients never see ours.',
            capability: 'partner-branding / partner-branding-resolution'
        },
        {
            title: 'A licence that defines the offer',
            detail: 'Seat and organisation limits with an expiry, plus feature entitlements that cap what any client account can have enabled.',
            capability: 'partner-licensing / partner-feature-entitlements'
        },
        {
            title: 'Provision clients yourself',
            detail: 'Create client organisations from the console, or import many at once by CSV with their provider credentials included.',
            capability: 'partner-org-provisioning / bulk-org-provisioning'
        },
        {
            title: 'One console across your portfolio',
            detail: 'Licence usage, every client organisation, their setup progress and the outstanding step for each, with a jump straight into any of them.',
            capability: 'partner-console-ui / partner-administration-ui'
        },
        {
            title: 'Set clients up on their behalf',
            detail: 'Work inside a client account to finish their onboarding, with every action attributed to you and visible to their own admins.',
            capability:
                'onboarding on-behalf attribution (bf9fdcf) / partner-admin-session'
        },
        {
            title: 'Portfolio comparison across clients',
            detail: 'A rollup across every organisation you own, with normalised league tables so different-sized clients can be compared.',
            capability:
                'portfolio-dashboard / portfolio-rankings-ui / partner-access-scoping'
        }
    ],

    asides: [
        {
            title: 'Your clients stay yours',
            body: 'Partner-owned accounts are scoped to you: your staff see only your portfolio, and the platform does not market itself to your clients. On your subdomain we hide our own pricing and never invite your prospects to become resellers themselves, including if your licence lapses.',
            capability:
                'partner-access-scoping / partner-tenancy / partner-branding-resolution'
        }
    ],

    proofPoints: [
        'The full product (dashboards, alerts, targets, carbon reporting, portfolio), not a cut-down tier',
        'Your commercial terms with your clients are yours to set; we never quote our prices to them',
        'Onboarding support while you get your first clients live'
    ],

    ctaTitle: 'Talk to us about a partnership',
    ctaBody:
        'Tell us the market you serve and roughly how many client sites you expect, and we will walk you through licensing and what white-labelling involves.'
}
